export function CloudAdoption() {
    return (
        <h2>Cloud Adoption</h2>
    )
}